import { __decorate, __metadata } from "tslib";
import { Title } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { EMAIL_ID_PATTERN, NAME_PATTERN, OPTIONAL_NAME_PATTERN, UK_PHONE_NUMBER_PATTERN, } from '../utils/regex.js';
export class IndividualPersonalDetails extends BaseMessage {
    title;
    firstName;
    middleName;
    lastName;
    birthDate;
    emailId;
    phoneNumber;
    countryPhoneCode;
    phoneType;
    deviceType;
    electronicPartyAddressType;
    electronicAddressType;
    createdBy;
    updatedBy;
}
__decorate([
    Field.enum({
        enum: Title,
        description: 'Title of an individual',
        required: true,
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "title", void 0);
__decorate([
    Field.string({
        description: 'First Name of an individual',
        required: true,
        maxLength: 30,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "firstName", void 0);
__decorate([
    Field.string({
        description: 'Middle Name of an individual',
        required: false,
        maxLength: 30,
        pattern: OPTIONAL_NAME_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "middleName", void 0);
__decorate([
    Field.string({
        description: 'Last Name of an individual',
        required: true,
        maxLength: 80,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "lastName", void 0);
__decorate([
    Field.string({
        description: 'Birth date of an individual',
        required: false,
        format: 'date',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "birthDate", void 0);
__decorate([
    Field.string({
        description: 'Email Id of an individual',
        required: true,
        maxLength: 80,
        pattern: EMAIL_ID_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "emailId", void 0);
__decorate([
    Field.string({
        description: 'Phone Number of an individual',
        required: true,
        maxLength: 11,
        pattern: UK_PHONE_NUMBER_PATTERN,
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "phoneNumber", void 0);
__decorate([
    Field.string({
        description: 'Country Phone code',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "countryPhoneCode", void 0);
__decorate([
    Field.string({
        description: 'Phone type',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "phoneType", void 0);
__decorate([
    Field.string({
        description: 'device type',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "deviceType", void 0);
__decorate([
    Field.string({
        description: 'electronic party address type',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "electronicPartyAddressType", void 0);
__decorate([
    Field.string({
        description: 'electronic address type',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "electronicAddressType", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "createdBy", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], IndividualPersonalDetails.prototype, "updatedBy", void 0);
//# sourceMappingURL=IndividualPersonalDetails.js.map